import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { IQObservationService } from '../../core/services/iq-observation';
import * as iqObservationsActions from '../actions/get-iq-observations.action';

@Injectable()
export class IQObservationEffects {
  private readonly concreteService$ = inject(IQObservationService);

  private readonly actions$ = inject(Actions);

  getIQObservations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(iqObservationsActions.GET_IQ_OBSERVATIONS),
      switchMap(({ payload: { showMockData } }) =>
        this.concreteService$.getObservations({ showMockData }).pipe(
          map(
            (observations) =>
              new iqObservationsActions.GetIQObservationsSuccess(observations),
          ),
          catchError((error) =>
            of(new iqObservationsActions.GetIQObservationsFail(error)),
          ),
        ),
      ),
    ),
  );
}
